import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CategorySelectData, ProcedureEditData, procedureEditDataSchema } from '@shared/types';
import { ViewEditDialog } from '@web/components/ui/view-edit-dialog';
import { ProcedureDetailsForm } from './procedures-details-form';

type ProcedureDetailsCardProps = {
  procedure: ProcedureEditData;
  categoryList: CategorySelectData[],
  onSubmit: (data: ProcedureEditData) => Promise<void>;
  onClose?: () => void;
};

export function ProcedureDetailsCard({
  procedure,
  categoryList,
  onSubmit,
  onClose,
}: Readonly<ProcedureDetailsCardProps>) {
  const form = useForm<ProcedureEditData>({
    resolver: zodResolver(procedureEditDataSchema),

    defaultValues: procedure,
  });

  return (
    <ViewEditDialog
      title="Procedure Details"
      onSubmit={form.handleSubmit(onSubmit)}
      onClose={onClose}
      render={({ isEditMode, setIsSubmitting }) => (
        <ProcedureDetailsForm
          form={form}
          isEditMode={isEditMode}
          setIsSubmitting={setIsSubmitting}
          categoryList={categoryList}
          onSubmit={async (data) => {
            await onSubmit(data);
            onClose?.();
          }}
        />
      )}
    />
  );
}
